import { sel } from "../../academy/selectors";
import { TutorialDefinition } from "../types";

/**
 * Academy "Your style" lesson: call signs. Started from the lesson page in a
 * new tab; never auto-started. Walks the officer's own Report Preferences
 * page, then points at where the per-report override lives in the upload
 * modal.
 */
const tour: TutorialDefinition = {
  id: "call-signs",
  version: "1.0.0",
  releasedAt: "2026-10-29T00:00:00.000Z",
  category: "onboarding",
  title: "Call signs",
  description: "Set your call sign, its format, and where it appears.",
  triggerRoute: /^\/preferences$/,
  startRoute: "/preferences",
  lessonId: "call-signs",
  autoStart: false,
  steps: [
    {
      target: '[data-pref="include_call_sign"]',
      waitFor: '[data-pref="include_call_sign"]',
      waitTimeoutMs: 10000,
      title: "Include Call Sign",
      content: "Turn this on. The Call Sign, Call Sign Format, and Call Sign Placement fields appear below it.",
      disableBeacon: true,
      placement: "top",
    },
    {
      target: '[data-pref="call_sign"]',
      waitFor: '[data-pref="call_sign"]',
      title: "Your call sign",
      content: "Click the button and type your call sign, for example 1-1.",
      disableBeacon: true,
      placement: "top",
    },
    {
      target: '[data-pref="call_sign_format"]',
      waitFor: '[data-pref="call_sign_format"]',
      title: "Call Sign Format",
      content:
        "Each option is built from your real rank, name, and badge, so you see exactly how it will read. The badge appears only when Include Badge Number is on.",
      disableBeacon: true,
      placement: "top",
    },
    {
      target: '[data-pref="call_sign_mention"]',
      waitFor: '[data-pref="call_sign_mention"]',
      title: "Call Sign Placement",
      content: "Choose First mention only, or Every mention.",
      disableBeacon: true,
      placement: "top",
    },
    {
      target: sel("preferencesSave"),
      waitFor: sel("preferencesSave"),
      title: "Save",
      content: "Click Save Preferences.",
      disableBeacon: true,
      placement: "top",
    },
    {
      target: sel("newCaseDropdown"),
      waitFor: sel("newCaseDropdown"),
      title: "Change it for one report",
      content:
        "When you upload, open Report Settings. Call Sign for This Report is pre-filled with your default. Change it there and it applies to that case only.",
      disableBeacon: true,
      placement: "right",
    },
  ],
};

export default tour;
